import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import messages from '../../locale/messages';
import ChangePasswordContainer from './ChangePasswordContainer';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';

const title = 'Change Password';

export default function action({ store, intl }) {

  const title = intl?.formatMessage(messages.changePasswordLabel);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout hideMenu>
      <DashboardLayout>
        <ChangePasswordContainer title={title} />
      </DashboardLayout>
    </UserLayout>,
  };
}
